import { jsx as l } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import * as o from "@radix-ui/react-collapsible";
import { twMerge as a } from "tailwind-merge";
const i = o.Root, n = o.Trigger, p = s(
  ({ className: t, ...e }, r) => /* @__PURE__ */ l(
    o.Content,
    {
      ref: r,
      className: a(
        "radix-state-closed:animate-collapsibleUp radix-state-open:animate-collapsibleDown overflow-hidden",
        t
      ),
      ...e
    }
  )
), g = i, C = n, b = p;
export {
  p as CollapsibleContent,
  i as CollapsibleRoot,
  n as CollapsibleTrigger,
  b as Content,
  g as Root,
  C as Trigger
};
